import firebase from 'firebase/app'
import 'firebase/firestore'

// Get a Firestore instance
export const db = firebase
    .initializeApp(
        {
            apiKey: "AIzaSyBj7NwFv7iYiFCVU41x-LuTweR42fftuIY",
            authDomain: "oeskb-app.firebaseapp.com",
            databaseURL: "https://oeskb-app.firebaseio.com",
            projectId: "oeskb-app",
            storageBucket: "oeskb-app.appspot.com",
            messagingSenderId: "726229521772",
            appId: "1:726229521772:web:b64d9582d562f7e48c0f49"
/*
            apiKey: "AIzaSyDcCPGkv3xsvFVPX4wxNqhEtPYJKIXBytI",
            authDomain: "oeskb-dev.firebaseapp.com",
            databaseURL: "https://oeskb-dev.firebaseio.com",
            projectId: "oeskb-dev",
            storageBucket: "oeskb-dev.appspot.com",
            messagingSenderId: "875652133368",
            appId: "1:875652133368:web:4baa6ec69aae3b6516660d"
*/
/*
            apiKey: "AIzaSyAdmXtWtPeiZMaJ_4a_p20jKSOFVS0TGeg",
            authDomain: "oeskb-test.firebaseapp.com",
            databaseURL: "https://oeskb-test.firebaseio.com",
            projectId: "oeskb-test",
            storageBucket: "oeskb-test.appspot.com",
            messagingSenderId: "218834995098",
            appId: "1:218834995098:web:f8f0b70144e15af4289c23"
*/
/*
            apiKey: "AIzaSyBj7NwFv7iYiFCVU41x-LuTweR42fftuIY",
            authDomain: "oeskb-app.firebaseapp.com",
            databaseURL: "https://oeskb-app.firebaseio.com",
            projectId: "oeskb-app",
            storageBucket: "oeskb-app.appspot.com",
            messagingSenderId: "726229521772",
            appId: "1:726229521772:web:b64d9582d562f7e48c0f49"
*/
        }
    )
    .firestore();

// Export types that exists in Firestore
// This is not always necessary, but it's used in other examples
const { TimeStamp, GeoPoint } = firebase.firestore;
export { TimeStamp, GeoPoint }

export const firestore = firebase.firestore;
require("firebase/functions");
export const firestoreFunctions = firebase.functions();

// if using Firebase JS SDK < 5.8.0
//db.settings({ timestampsInSnapshots: true })